module.exports = __webpack_public_path__ + "dummyImage.png?b45e02bc97292f9df392db690d792a93";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/dummyImage.png
// module id = 196
// module chunks = 0